<template>
  <div>
    <v-header :account_info="account_info" :account_name="account_name"></v-header>
    <Row style="height:30px;"></Row>
    <Row type="flex" justify="space-around">
      <Col span="4">
        <Card @click.native="change_balance_type" style="cursor:pointer;">
          <h4 slot="title" style="text-align:center;white-space:nowrap;">
            <Tooltip placement="top" content="单击切换 usd/xbt" delay:1000>账户总余额</Tooltip>
          </h4>
          <p
            v-if="balance_type == 'usd'"
            style="font-size:30px;text-align:center;white-space:nowrap"
          >
            {{ balance_usd_show }}
            <Icon type="logo-usd" style="margin-top:-10px;" />
          </p>
          <p v-else style="font-size:30px;text-align:center;white-space:nowrap">
            {{ balance_xbt }}
            <Icon type="logo-bitcoin" style="margin-top:-10px;" />
          </p>
        </Card>
      </Col>
      <Col span="4">
        <Card>
          <h4 slot="title" style="text-align:center;white-space:nowrap;">账户盈利率</h4>
          <p
            style="font-size:30px;text-align:center;white-space:nowrap;"
          >{{ account_current_profit }} %</p>
        </Card>
      </Col>
      <!-- <Col span="4">
        <Card>
          <h4 slot="title" style="text-align:center;white-space:nowrap;">绑定子策略</h4>
          <p style="font-size:30px;text-align:center;white-space:nowrap;">{{ child_strategy_num }} 个</p>
        </Card>
      </Col>
      <Col span="4">
        <Card>
          <h4 slot="title" style="text-align:center;white-space:nowrap;">总交易次数</h4>
          <p style="font-size:30px;text-align:center;white-space:nowrap;">{{ total_trade_number }}</p>
        </Card>
      </Col> -->
      <Col span="4">
        <Card>
          <h4 slot="title" style="text-align:center;white-space:nowrap;">当前杠杆率</h4>
          <p style="font-size:30px;text-align:center;white-space:nowrap;">{{ current_leverage }} x</p>
        </Card>
      </Col>
    </Row>
    <Row style="height:30px;"></Row>
    <!-- <Row type="flex" justify="space-around">
      <Col span="11">
        <div ref="percent_bar_equity_ref" style="float:left;width:100%;height:300px"></div>
      </Col>
      <Col span="11">
        <div ref="percent_bar_holding_value_ref" style="float:left;width:100%;height:300px"></div>
      </Col>
    </Row>
    <Row style="height:14px;"></Row> -->
    <!-- <Row type="flex" justify="space-between">
      <Col span="24">
        <h3 style="color:#893448;font-size:18px;letter-spacing:0.4px;white-space: nowrap;">账户当前持仓</h3>
      </Col>
    </Row> -->
    <Row style="height:10px;"></Row>
    <Row type="flex" justify="space-between">
      <Col span="24">
        <!-- <Table stripe :columns="holding_table_columns" :data="holding_table_data"></Table> -->
        <v-table
              :title="this.holding_table_title"
              :title_info="this.holding_table_info"
              :table_columns="this.holding_table_columns_vtable"
              :table_data="this.holding_table_data_vtable"
              :table_ref="this.tabs_labe3_ref"
              :max_height="600"
              :init_table="this.holding_table_init_table_func"
              :table_name_array="this.holding_table_array"
        ></v-table>
      </Col>
    </Row>
    <Row style="height:30px;"></Row>
    <Row>
      <Col span="24">
        <Tabs :value="tabs_name" type="card" @on-click="tab_select">
          <TabPane :label="tabs_label" name="name1">
            <div ref="echarts_curve_ref" style="width:100%;height:500px;margin:0 auto;"></div>
          </TabPane>
          <TabPane :label="tabs_labe2" name="name2">
            <div ref="echarts_drawdown_ref" style="width:100%;height:500px;margin:0 auto;"></div>
          </TabPane>
          <TabPane :label="tabs_labe3" name="name3" v-if="!account_not_show.includes(this.account_id)">
            <v-table
              :title="this.transaction_record_title"
              :title_info="this.transaction_record_info"
              :table_columns="this.transaction_record_table_columns"
              :table_data="this.transaction_record_table_data"
              :table_ref="this.transaction_record_ref"
              :max_height="600"
              :init_table="this.transaction_record_init_table_func"
              :table_name_array="this.transaction_name_array"
            ></v-table>
          </TabPane>
          <TabPane :label="tabs_labe4" name="name4" v-if="!account_not_show.includes(this.account_id)">
            <v-table
              :title="this.open_orders_record_title"
              :title_info="this.open_orders_record_info"
              :table_columns="this.open_orders_record_table_columns"
              :table_data="this.open_orders_record_table_data"
              :table_ref="this.open_orders_record_ref"
              :max_height="600"
              :table_page_size="20"
              :init_table="this.open_orders_record_init_table_func"
              :table_name_array="this.open_orders_name_array"
            ></v-table>
          </TabPane>
          <TabPane :label="tabs_labe5" name="name5" v-if="!account_not_show.includes(this.account_id)">
            <v-table
              :title="this.api_key_record_title"
              :title_info="this.api_key_record_info"
              :table_columns="this.api_key_record_table_columns"
              :table_data="this.api_key_record_table_data"
              :table_ref="this.api_key_record_ref"
              :max_height="600"
              :init_table="this.api_key_record_init_table_func"
              :table_name_array="this.api_key_name_array"
            ></v-table>
          </TabPane>
          <TabPane :label="tabs_labe6" name="name6" v-if="!account_not_show.includes(this.account_id)">
            <v-table
              :title="this.user_events_record_title"
              :title_info="this.user_events_record_info"
              :table_columns="this.user_events_record_table_columns"
              :table_data="this.user_events_record_table_data"
              :table_ref="this.user_events_record_ref"
              :max_height="600"
              :init_table="this.user_events_record_init_table_func"
              :table_name_array="this.user_events_name_array"
            ></v-table>
          </TabPane>
          <TabPane :label="tabs_labe7" name="name7" v-if="!account_not_show.includes(this.account_id)">
            <v-table
              :title="this.wallet_history_record_title"
              :title_info="this.wallet_history_record_info"
              :table_columns="this.wallet_history_record_table_columns"
              :table_data="this.wallet_history_record_table_data"
              :table_ref="this.wallet_history_record_ref"
              :max_height="600"
              :init_table="this.wallet_history_record_init_table_func"
              :table_name_array="this.wallet_history_name_array"
            ></v-table>
          </TabPane>
          <TabPane :label="tabs_labe8" name="name8" v-if="!account_not_show.includes(this.account_id)">
            <v-table
              :title="this.interest_history_record_title"
              :title_info="this.interest_history_record_info"
              :table_columns="this.interest_history_record_table_columns"
              :table_data="this.interest_history_record_table_data"
              :table_ref="this.interest_history_record_ref"
              :max_height="600"
              :init_table="this.interest_history_record_init_table_func"
              :table_name_array="this.interest_history_name_array"
            ></v-table>
          </TabPane>
        </Tabs>
      </Col>
    </Row>
  </div>
</template>

<script>
import {
  draw_line_chart,
  draw_pie_chart,
  draw_bar_chart,
  array_to_object,
  num_format
} from "../utils";
import child_header_view from "../components/headerView.vue";
import table_view from "../components/TableView.vue";
export default {
  name: "account_overview",
  components: {
    "v-header": child_header_view,
    "v-table": table_view
  },
  data() {
    return {
      acccount_id: null,
      account_info: [
        { name: "编号", value: "78" },
        { name: "账户说明", value: "短期测试账户1" }
      ],
      account_name: "账户: rexxer5@outlook.com",
      // 不需要展示除净值回撤之外标签页的账户
      account_not_show:['81','82','84','85','86','88','89','90','91'],
      btc_account_lists:['83','84','85','86','87','88','89','90','91','94','95','96'],
      timer: null,
      balance_usd_show: null,
      balance_usd: 17730,
      balance_xbt: 10.57,
      child_strategy_num: 6,
      total_trade_number: 6571,
      account_current_profit: 10.17,
      exchange_name: "binance",
      current_leverage: "0",
      balance_type: "xbt",
      orgOptions: {},
      myChart: "",
      tabs_name: "name1",
      holding_table_title:"账户当前持仓",
      tabs_label: "净值曲线",
      tabs_labe2: "回撤曲线",
      tabs_labe3: "8小时交割记录",
      tabs_labe4: "当前委托",
      tabs_labe5: "当前apiKey",
      tabs_labe6: "用户事件",
      tabs_labe7: "充提币信息",
      tabs_labe8: "缴纳利息记录",
      curve_usd: "",
      curve_xbt: "",
      drawdown_usd: "",
      drawdown_xbt: "",
      holding_table_columns: [
        { title: "合约", key: "currency_name", align: "center" },
        { title: "合约现价", key: "currency_price", align: "center" },
        { title: "目前仓位数量", key: "amount", align: "center" },
        {
          title: "仓位价值",
          key: "holding_child_strategy_amount",
          align: "center"
        },
        { title: "开仓价格", key: "open_price", align: "center" },
        { title: "强平价格", key: "burst_price", align: "center" },
        {
          title: "能承受的最大不利波动",
          key: "risk_limit_max_fluctuation",
          align: "center"
        }
      ],
      holding_table_array: [
        "合约", "合约现价", "目前仓位数量","仓位价值","开仓价格","强平价格",
        "能承受的最大不利波动"
      ],
      holding_table_key_array: [
        "currency_name", "currency_price", "amount", "holding_child_strategy_amount",
        "open_price", "burst_price", "risk_limit_max_fluctuation"
      ],
      holding_table_info: [],
      holding_table_data_vtable: [],
      transaction_record_title: "账户8小时记录",
      transaction_record_info: [
        { name: "总计收入BTC数量 ", value: 0 },
        { name: "总计收入USDT数量 ", value: 0 }
      ],
      holding_table_data:[],
      holding_table_columns_vtable:[],
      transaction_record_table_columns: [],
      transaction_record_table_data: [],
      transaction_record_ref: "transaction_record_ref",
      tabs_labe3_ref: "tabs_labe3_ref",
      transaction_name_array: [
        "时间",
        "合约",
        "成交类别",
        "方向",
        "成交数量",
        "成交价格",
        "价值",
        "佣金费率",
        "已付费用",
        "委托种类",
        "委托数量",
        "未成交数量",
        "委托价格",
        "委托ID",
        "用户ID"
      ],

      open_orders_record_title: "",
      open_orders_record_info: [],
      open_orders_record_table_columns: [],
      open_orders_record_table_data: [],
      open_orders_record_ref: "open_orders_record_ref",
      open_orders_name_array: [
        "时间",
        "合约",
        "方向",
        "委托数量",
        "委托价格",
        "委托种类",
        "已成交数量",
        "隶属子策略",
        "用户定义ID",
        "交易ID"
      ],

      api_key_record_title: "",
      api_key_record_info: [],
      api_key_record_table_columns: [],
      api_key_record_table_data: [],
      api_key_record_ref: "api_key_record_ref",
      api_key_name_array: [
        "时间",
        "名称",
        "apiKey",
        "权限",
        "设定可用IP",
        "启用状态",
      ],

      user_events_record_title: "",
      user_events_record_info: [],
      user_events_record_table_columns: [],
      user_events_record_table_data: [],
      user_events_record_ref: "user_events_record_ref",
      user_events_name_array: [
        "时间",
        "事件类型",
        "事件状态",
        "事件所在国家",
        "事件发生IP",
        "浏览器信息",
      ],

      wallet_history_record_title: "",
      wallet_history_record_info: [],
      wallet_history_record_table_columns: [],
      wallet_history_record_table_data: [],
      wallet_history_record_ref: "wallet_history_record_ref",
      wallet_history_name_array: [
        "时间",
        "事件类型",
        "数量",
        "手续费",
        "事件状态",
        "相关地址",
        "事件编号"
      ],

      interest_history_record_title: "",
      interest_history_record_info: [],
      interest_history_record_table_columns: [],
      interest_history_record_table_data: [],
      interest_history_record_ref: "interest_history_record_ref",
      interest_history_name_array: [
        "时间",
        "利息类型",
        "借贷币种",
        "借贷数量",
        "利息币种",
        "利息数量",
        "日利率",
        "事件流水号"
      ]

    };
  },
  watch: {
    balance_usd(old_value) {
      this.balance_usd_show = num_format(this.balance_usd);
    },
    balance_type(old_value) {
      this.flush_line_chart()
      this.flush_account_current_profit();
    }
    
  },
  methods: {
    flush_line_chart: function() {
      if (this.balance_type == "xbt") {
        draw_line_chart(
          this.$refs.echarts_curve_ref,
          this.curve_xbt["name"],
          this.curve_xbt["x_data"],
          this.curve_xbt["y_data"]
        )
        draw_line_chart(
          this.$refs.echarts_drawdown_ref,
          this.drawdown_xbt["name"],
          this.drawdown_xbt["x_data"],
          this.drawdown_xbt["y_data"]
        )
      } else {
        draw_line_chart(
          this.$refs.echarts_curve_ref,
          this.curve_usd["name"],
          this.curve_usd["x_data"],
          this.curve_usd["y_data"]
        )
        draw_line_chart(
          this.$refs.echarts_drawdown_ref,
          this.drawdown_usd["name"],
          this.drawdown_usd["x_data"],
          this.drawdown_usd["y_data"]
        )
      }
    },
    load_tables_data: async function(timestamp = "") {
      let transaction_record_data = await this.$axios.get(
        this.$store.state.urlPort + "/load_echarts_data",
        {
          params: {
            mode: "transaction_funding_record",
            which_web_need: this.account_id,
            timestamp: timestamp
          }
        }
      );
      this.set_transaction_record_data(transaction_record_data);

      let user_events_record_data = await this.$axios.get(
        this.$store.state.urlPort + "/load_echarts_data",
        {
          params: {
            mode: "user_events_record",
            which_web_need: this.account_id,
            timestamp: timestamp
          }
        }
      );
      this.set_user_events_record_data(user_events_record_data);

      let wallet_history_record_data = await this.$axios.get(
        this.$store.state.urlPort + "/load_echarts_data",
        {
          params: {
            mode: "wallet_history_record",
            which_web_need: this.account_id,
            timestamp: timestamp
          }
        }
      );
      this.set_wallet_history_record_data(wallet_history_record_data);

      let interest_history_record_data = await this.$axios.get(
        this.$store.state.urlPort + "/load_echarts_data",
        {
          params: {
            mode: "interest_history_record",
            which_web_need: this.account_id,
            timestamp: timestamp
          }
        }
      );
      this.set_interest_history_record_data(interest_history_record_data);

    },
    holding_table_init_table_func: function() {
      const name_array = this.holding_table_array;
      this.holding_table_columns_vtable = [];
      for (var i = 0; i < name_array.length; i++) {
        this.holding_table_columns_vtable.push({
          title: name_array[i],
          key: name_array[i],
          align: "center"
        });
      }
    },
    transaction_record_init_table_func: function() {
      const name_array = this.transaction_name_array;
      this.transaction_record_table_columns = [];
      for (var i = 0; i < name_array.length; i++) {
        this.transaction_record_table_columns.push({
          title: name_array[i],
          key: name_array[i],
          align: "center"
        });
      }
      this.transaction_record_table_columns[0]["width"] = 155;
      //this.transaction_record_table_columns[0]["className"] = 'demo-table-info-column'
      this.transaction_record_table_columns[1]["width"] = 155;
      //this.transaction_record_table_columns[2]["width"] = 90;
      //this.transaction_record_table_columns[3]["width"] = 85;
      this.transaction_record_table_columns[3]["render"] = (h, params) => {
        var value = params["row"][params["column"]["key"]];
        var buy_sell = params["row"]["方向"].toLowerCase();
        return h("div", [
          h(
            "span",
            {
              style: {
                color: buy_sell.indexOf("buy") != -1 ? "#006633" : "#ed4014"
              }
            },
            value
          )
        ]);
      };
      //this.transaction_record_table_columns[4]["width"] = 85;
      this.transaction_record_table_columns[4]["render"] = (h, params) => {
        var value = params["row"][params["column"]["key"]];
        var buy_sell = params["row"]["方向"].toLowerCase();
        return h("div", [
          h(
            "span",
            {
              style: {
                color: buy_sell.indexOf("buy") != -1 ? "#006633" : "#ed4014"
              }
            },
            value
          )
        ]);
      };
      //this.transaction_record_table_columns[5]["width"] = 90;
      // 价值
      //this.transaction_record_table_columns[6]["width"] = 200;
      //this.transaction_record_table_columns[7]["width"] = 90;
      this.transaction_record_table_columns[7]["render"] = (h, params) => {
        var value = params["row"][params["column"]["key"]];
        return h("div", [
          h(
            "span",
            {
              style: {
                color: value.indexOf("-") != -1 ? "#006633" : "#515a6e"
              }
            },
            value
          )
        ]);
      };
      //this.transaction_record_table_columns[8]["width"] = 150;
      this.transaction_record_table_columns[8]["render"] = (h, params) => {
        var value = params["row"][params["column"]["key"]];
        return h("div", [
          h(
            "span",
            {
              style: {
                color: value.indexOf("-") != -1 ? "#006633" : "#515a6e"
              }
            },
            value
          )
        ]);
      };
      //this.transaction_record_table_columns[9]["width"] = 90;
      //this.transaction_record_table_columns[10]["width"] = 85;
      this.transaction_record_table_columns[10]["render"] = (h, params) => {
        var value = params["row"][params["column"]["key"]];
        var buy_sell = params["row"]["方向"].toLowerCase();
        return h("div", [
          h(
            "span",
            {
              style: {
                color: buy_sell.indexOf("buy") != -1 ? "#006633" : "#ed4014"
              }
            },
            value
          )
        ]);
      };
      //this.transaction_record_table_columns[11]["width"] = 100;
      //this.transaction_record_table_columns[12]["width"] = 90;
      //this.transaction_record_table_columns[13]["minWidth"] = 65;
      //this.transaction_record_table_columns[14]["minWidth"] = 65;

      this.transaction_record_table_columns[13]["tooltip"] = true;
      this.transaction_record_table_columns[14]["tooltip"] = true;
    },
    open_orders_record_init_table_func: function() {
      const name_array = this.open_orders_name_array;
      this.open_orders_record_table_columns = [];
      for (var i = 0; i < name_array.length; i++) {
        this.open_orders_record_table_columns.push({
          title: name_array[i],
          key: name_array[i],
          align: "center"
        });
      }
      this.open_orders_record_table_columns[0]["minWidth"] = 155;
      this.open_orders_record_table_columns[1]["minWidth"] = 90;
      this.open_orders_record_table_columns[2]["minWidth"] = 65;
      this.open_orders_record_table_columns[2]["render"] = (h, params) => {
        var value = params["row"][params["column"]["key"]];
        return h("div", [
          h(
            "span",
            {
              style: {
                color: value.indexOf("Buy") != -1 ? "#006633" : "#ed4014"
              }
            },
            value
          )
        ]);
      };
      this.open_orders_record_table_columns[3]["minWidth"] = 85;
      this.open_orders_record_table_columns[3]["render"] = (h, params) => {
        var value = params["row"][params["column"]["key"]];
        var buy_or_sell = params["row"]["方向"];
        return h("div", [
          h(
            "span",
            {
              style: {
                color: buy_or_sell.indexOf("Buy") != -1 ? "#006633" : "#ed4014"
              }
            },
            value
          )
        ]);
      };
      this.open_orders_record_table_columns[4]["minWidth"] = 100;
      this.open_orders_record_table_columns[5]["minWidth"] = 100;
      this.open_orders_record_table_columns[6]["minWidth"] = 100;
      this.open_orders_record_table_columns[7]["minWidth"] = 100;
      this.open_orders_record_table_columns[8]["minWidth"] = 85;
      this.open_orders_record_table_columns[8]["tooltip"] = true;

      this.open_orders_record_table_columns[9]["minWidth"] = 85;
      this.open_orders_record_table_columns[9]["tooltip"] = true;
    },
    api_key_record_init_table_func: function() {
      const name_array = this.api_key_name_array;
      this.api_key_record_table_columns = [];
      for (var i = 0; i < name_array.length; i++) {
        this.api_key_record_table_columns.push({
          title: name_array[i],
          key: name_array[i],
          align: "center"
        });
      }
      this.api_key_record_table_columns[0]["minWidth"] = 155;
      this.api_key_record_table_columns[2]["tooltip"] = true;
      this.api_key_record_table_columns[3]["tooltip"] = true;
      this.api_key_record_table_columns[4]["tooltip"] = true;
      this.api_key_record_table_columns[5]["render"] = (h, params) => {
        var value = params["row"][params["column"]["key"]];
        return h("div", [
          h(
            "span",
            {
              style: {
                color: value.indexOf("启用") != -1 ? '#006633':'#ed4014'
              }
            },
            value
          )
        ]);
      };
    },
    user_events_record_init_table_func: function() {
      const name_array = this.user_events_name_array;
      this.user_events_record_table_columns = [];
      for (var i = 0; i < name_array.length; i++) {
        this.user_events_record_table_columns.push({
          title: name_array[i],
          key: name_array[i],
          align: "center"
        });
      }

      this.user_events_record_table_columns[0]["minWidth"] = 155;
      this.user_events_record_table_columns[4]["tooltip"] = true;
      this.user_events_record_table_columns[5]["tooltip"] = true;
      this.user_events_record_table_columns[2]["render"] = (h, params) => {
        var value = params["row"][params["column"]["key"]];
        return h("div", [
          h(
            "span",
            {
              style: {
                color: value.indexOf("success") != -1 ? '#006633':'#ed4014'
              }
            },
            value
          )
        ]);
      };
    },
    wallet_history_record_init_table_func: function() {
      const name_array = this.wallet_history_name_array;
      this.wallet_history_record_table_columns = [];
      for (var i = 0; i < name_array.length; i++) {
        this.wallet_history_record_table_columns.push({
          title: name_array[i],
          key: name_array[i],
          align: "center"
        });
      }
      this.wallet_history_record_table_columns[0]["minWidth"] = 155;
      this.wallet_history_record_table_columns[5]["tooltip"] = true;
      this.wallet_history_record_table_columns[6]["tooltip"] = true;
      this.wallet_history_record_table_columns[4]["render"] = (h, params) => {
        var value = params["row"][params["column"]["key"]];
        return h("div", [
          h(
            "span",
            {
              style: {
                color: value.indexOf("成功划转") != -1 ? '#006633':'#ed4014'
              }
            },
            value
          )
        ]);
      };
      this.wallet_history_record_table_columns[1]["render"] = (h, params) => {
        var value = params["row"][params["column"]["key"]];
        var if_succeed = params["row"]["事件状态"];
        return h("div", [
          h(
            "span",
            {
              style: {
                color: if_succeed.indexOf("成功划转") != -1 ? '#006633':'#ed4014'
              }
            },
            value
          )
        ]);
      };
    },
    interest_history_record_init_table_func: function() {
      const name_array = this.interest_history_name_array;
      this.interest_history_record_table_columns = [];
      for (var i = 0; i < name_array.length; i++) {
        this.interest_history_record_table_columns.push({
          title: name_array[i],
          key: name_array[i],
          align: "center"
        });
      }
      // "时间", "利息类型", "借贷币种", "借贷数量", "利息币种", "利息数量", "日利率", "事件流水号"
      this.interest_history_record_table_columns[1]["minWidth"] = 150;
      this.interest_history_record_table_columns[1]["tooltip"] = true;
    },
    // 将后台传递过来的open_orders_record信息，拆分进对应的结构中
    set_open_orders_record_data: function(data) {
      this.open_orders_record_table_data = data["data"];
      this.open_orders_record_title = data["name"];
      this.open_orders_record_info = [
        { name: "买单委托总数", value: data["total_buy_amount"] },
        { name: "卖单委托总数", value: data["total_sell_amount"] }
      ];
    },
    set_transaction_record_data: function(data) {
      this.transaction_record_title = data["name"];
      this.transaction_record_info = [
        { name: "总计收入BTC数量 ", value: (parseFloat(this.transaction_record_info[0]["value"]) + parseFloat(data["xbt_amount"])).toFixed(8) + " BTC" },
        { name: "总计收入USDT数量 ", value: (parseFloat(this.transaction_record_info[1]["value"]) + parseFloat(data["usd_amount"])).toFixed(2) + " USDT" }
      ];
      for (var i = 0; i < data["data"].length; i++) {
        this.transaction_record_table_data.push(data["data"][i])
      }
    },
    set_api_key_record_data: function(data) {
      this.api_key_record_title = data["name"];
      this.api_key_record_info = [
        { name: "总计数量 ", value: data["data"].length},
      ];
      this.api_key_record_table_data = data["data"];
    },
    set_user_events_record_data: function(data) {
      this.user_events_record_title = data["name"];
      
      for (var i = 0; i < data["data"].length; i++) {
        this.user_events_record_table_data.push(data["data"][i])
      }

      this.user_events_record_info = [
        { name: "总计事件数量 ", value: this.user_events_record_table_data.length },
      ];
    },
    set_wallet_history_record_data: function(data) {
      this.wallet_history_record_title = data["name"];
      
      for (var i = 0; i < data["data"].length; i++) {
        this.wallet_history_record_table_data.push(data["data"][i])
      }
      this.wallet_history_record_info = [
        { name: "总计事件数量 ", value: this.wallet_history_record_table_data.length },
      ];
    },
    set_interest_history_record_data: function(data) {
      this.interest_history_record_title = data["name"];
      
      for (var i = 0; i < data["data"].length; i++) {
        this.interest_history_record_table_data.push(data["data"][i])
      }
      this.interest_history_record_info = [
        { name: "总计事件数量 ", value: this.interest_history_record_table_data.length },
      ];
    },

    tab_select: function(name) {
      localStorage.setItem("tab_select_name_account_overview", name);
    },
    change_balance_type: function() {

      if (this.balance_type == "usd") {
        this.balance_type = "xbt"
      } else {
        this.balance_type = "usd"
      }
      // if (this.balance_type == "usd") {
      //   this.balance_type = "xbt";
      //   draw_line_chart(
      //     this.$refs.echarts_curve_ref,
      //     this.curve_xbt["name"],
      //     this.curve_xbt["x_data"],
      //     this.curve_xbt["y_data"]
      //   );
      //   draw_line_chart(
      //     this.$refs.echarts_drawdown_ref,
      //     this.drawdown_xbt["name"],
      //     this.drawdown_xbt["x_data"],
      //     this.drawdown_xbt["y_data"]
      //   );
      // } else {
      //   this.balance_type = "usd";
      //   draw_line_chart(
      //     this.$refs.echarts_curve_ref,
      //     this.curve_usd["name"],
      //     this.curve_usd["x_data"],
      //     this.curve_usd["y_data"]
      //   );
      //   draw_line_chart(
      //     this.$refs.echarts_drawdown_ref,
      //     this.drawdown_usd["name"],
      //     this.drawdown_usd["x_data"],
      //     this.drawdown_usd["y_data"]
      //   );
      // }
      // this.flush_account_current_profit();
    },
    flush_account_current_profit() {
      if (this.curve_xbt.hasOwnProperty("y_data") == false) {
        return null;
      }
      if (this.balance_type == "xbt") {
        var final_share = this.curve_xbt["final_share"];
        var end = this.balance_xbt;
      } else {
        var final_share = this.curve_usd["final_share"];
        var end = this.balance_usd;
      }
      this.account_current_profit = (100 * (end / final_share - 1)).toFixed(2);
    },
    setTimer: function(interval, timer) {
      if (timer == null) {
        timer = setInterval(() => {
          this.load_echarts_need_update_data();
          this.load_static_data();
          this.load_tables_data(Date.parse(new Date()));
        }, interval);
      }
    },
    load_static_data: async function() {
      let data = await this.$axios.get(
        this.$store.state.urlPort + "/load_account_overview_static_data",
        { params: { which_web_need: this.account_id } }
      );
      this.current_leverage = data["current_leverage"];
      this.balance_usd = data["balance_usd"];
      this.balance_xbt = data["balance_xbt"];
      this.child_strategy_num = data["child_strategy_num"];
      this.total_trade_number = data["total_trade_number"];
      this.exchange_name = data["exchange_name"];
      this.account_info = data["account_info"];
      this.account_name = data["account_name"];
      this.holding_table_data = data["holding_table_data"];

      this.holding_table_data_vtable.length = 0
      for (var i = 0; i < this.holding_table_data.length; i++) {
        var value = []
        for (var name of this.holding_table_key_array) {
          value.push(this.holding_table_data[i][name])
        }
        this.holding_table_data_vtable.push(value)
      }

      this.set_open_orders_record_data(data["open_orders_data"]);
      this.set_api_key_record_data(data["api_key_msg"]);

      setTimeout(() => {
        this.flush_account_current_profit();
      }, 500);
    },
    load_echarts_need_update_data: async function() {
      this.holding_value = await this.$axios.get(
        this.$store.state.urlPort + "/load_echarts_data",
        {
          params: {
            mode: "holding_value",
            which_web_need: this.account_id
          }
        }
      );
      this.balance_overview = await this.$axios.get(
        this.$store.state.urlPort + "/load_echarts_data",
        {
          params: { mode: "balance_overview", which_web_need: this.account_id }
        }
      );
      draw_bar_chart(
        this.$refs.percent_bar_equity_ref,
        this.balance_overview["name"],
        this.balance_overview["x_data"],
        this.balance_overview["y_data"]
      );
      draw_bar_chart(
        this.$refs.percent_bar_holding_value_ref,
        this.holding_value["name"],
        this.holding_value["x_data"],
        this.holding_value["y_data"]
      );
    },
    load_echarts_data: async function() {
      this.curve_usd = await this.$axios.get(
        this.$store.state.urlPort + "/load_echarts_data",
        { params: { mode: "curve_usd", which_web_need: this.account_id } }
      );
      this.drawdown_usd = await this.$axios.get(
        this.$store.state.urlPort + "/load_echarts_data",
        { params: { mode: "drawdown_usd", which_web_need: this.account_id } }
      );
      this.curve_xbt = await this.$axios.get(
        this.$store.state.urlPort + "/load_echarts_data",
        { params: { mode: "curve_xbt", which_web_need: this.account_id } }
      );
      this.drawdown_xbt = await this.$axios.get(
        this.$store.state.urlPort + "/load_echarts_data",
        { params: { mode: "drawdown_xbt", which_web_need: this.account_id } }
      );

      this.flush_line_chart()
      this.flush_account_current_profit();
      await this.load_echarts_need_update_data();
    }
  },
  mounted() {
    // this.account_id = this.$route.path.split("=")[1];
    this.load_static_data();
    this.load_echarts_data();
    var tab_select_name = localStorage.getItem(
      "tab_select_name_account_overview"
    );
    if (tab_select_name != null) {
      this.tabs_name = tab_select_name;
    }
    this.load_tables_data();
  },
  created() {
    clearInterval(this.timer);
    this.timer = null;
    this.setTimer(30000, this.timer);

    this.account_id = this.$route.path.split("=")[1];
    if (this.btc_account_lists.includes(this.account_id)) {
      this.balance_type = "xbt"
    } else {
      this.balance_type = "usd"
    }
  },
  destroyed() {
    // 每次离开当前界面时，清除定时器
    clearInterval(this.timer);
    this.timer = null;
  }
};
</script>
    
<style scoped>
.header-collapse {
  background-color: rgba(255, 255, 255, 0.2);
}
.panel-name {
  display: flex;
  font-size: 18px;
  color: #2b85e4;
  letter-spacing: 0.4px;
  white-space: nowrap;
}
.panel-content {
  font-size: 15px;
  letter-spacing: 0.4px;
  white-space: nowrap;
}
</style>